// Auto-generated from octomil-contracts. Do not edit.

export enum FinishReason {
  Stop = "stop",
  ToolCalls = "tool_calls",
  Length = "length",
  ContentFilter = "content_filter",
}
